<template>
  <div>
  <v-row justify="center">
    <v-dialog v-model="verifyRequestDialog" persistent max-width="500px">
      <v-card justify="center">
        <v-card-title class="subtitle-1 green darken-2 white--text">{{ screenTitle }}</v-card-title>
       
       <v-card-text class="black--text">
        <v-row class="mt-1">
          <v-col cols="12" align="center" class="subtitle-2">
            <p v-html='$t("webmsg.mtr300.area")'></p>
          </v-col>
        </v-row>
        <v-row class="mt-3 mx-2">
          <v-col cols="12" align="left" class="pb-0">
            <!-- <v-text-field label="担当者名" placeholder='' clearable v-model='inputManagerName' :disabled="true"></v-text-field> -->
             <v-text-field label="担当者名" v-model='inputManagerName' color="grey darken-1" readonly></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-3 mx-2">
          <v-col cols="12" align="left" class="pb-0">
            <!-- <v-text-field label="担当者名(フリガナ)" placeholder='' clearable v-model='inputManagerNameKana' :disabled="true"></v-text-field> -->
            <v-text-field label="担当者名(フリガナ)" v-model='inputManagerNameKana' color="grey darken-1" readonly></v-text-field>
          </v-col>
        </v-row>
       </v-card-text>
        <!-- <v-divider></v-divider> -->

        <v-card-actions >
          <v-spacer></v-spacer>
          <v-row class="mb-2">
            <v-col cols="6" class="d-flex align-center justify-end">
              <v-btn class="green darken-2" dark @click="request()">本人確認依頼</v-btn>
            </v-col>
             <v-col cols="6" class="d-flex align-center justify-center">
              <v-btn class="green darken-2" dark @click="cancel()">キャンセル</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <comMessage :msg="dlgErrMsg.msg" :is-open="dlgErrMsg.isOpen" :do-yes="dlgErrMsg.doYes"></comMessage>
  <comMessage :msg="dlgMsgCompled.msg" :is-open="dlgMsgCompled.isOpen" :do-yes="dlgMsgCompled.doYes"></comMessage>
  </div>
</template>

<script>
import Constants from '../common/constants';
import Utils from '../common/utils';
export default {
  name: "MainteVerifyRequest",
  props: ["msg", "isOpen", "doYes", "doNo", "requestNo", "managerNameKana", "managerName", "mailAddress", "sex", "birthDate"],
  data() {
    return {
      verifyRequestDialog: false,
      screenTitle: "本人確認依頼",
      screenId: "MTR300",
      dlgErrMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgErrMsg.isOpen = false;
        },
      },
      dlgMsgCompled: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompled.isOpen = false;
        },
      },
    };
  },
  watch: {
    isOpen: function(val) {
      this.verifyRequestDialog = val;
    },
  },
  computed: {
    inputManagerNameKana: {
      get() {
        return this.managerNameKana;
      },
      set(value) {
        if (value == null) {
          value = "";
        }
        this.managerNameKana = value;
      }
    },
    inputManagerName: {
      get() {
        return this.managerName;
      },
      set(value) {
        if (value == null) {
          value = "";
        }
        this.managerName = value;
      }
    },
  },
  methods: {
    /**
     * 「確認依頼」ボタン押下
     */
    request: function() {
      let errList = new Array();
      if (this.inputManagerName == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['担当者']));
      }
      if (this.inputManagerNameKana == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['担当者(カナ)']));
      }
      if (errList.length > 0) {
        this.dlgErrMsg.msg = Utils.createMsgViewString(errList);
        this.dlgErrMsg.isOpen = true;
        return;
      }
      this.reqVerify();

    },
    /**
     * 「キャンセル」ボタン押下
     */
    cancel: function() {
      // プラン選択閉じる
      this.doNo();
      this.verifyRequestDialog = false;
    },
    reqVerify: async function() {
      let responseDto;
      try {
        let apiurl = Constants.URL_API_ERA100P01;
        // 入力データ
        let data = JSON.stringify(this.createRequestData());
        // API呼出
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            });
        responseDto = response.data;
        let requestResultData = responseDto.data;
        // 完了メッセージ表示
        if (!this.showDialogMsgAfterAPICall(responseDto)) {
          this.regsterVerifyResult(requestResultData);
        }
      } catch(error) {
        this.dlgErrMsg.msg = this.$i18n.t('msg.err.cm110', ['本人確認の依頼']);
        this.dlgErrMsg.isOpen = true;
      } 

    },
    createRequestData: function() {
      let reqData = {};
      reqData["systemId"] = Constants.SYS_ID_TOUKI;
      reqData["mailAddress"] = this.mailAddress;
      reqData["name"] = this.inputManagerName;
      reqData["nameKana"] = this.inputManagerNameKana;
      reqData["sex"] = this.sex;
      reqData["birthDate"] = this.birthDate;
      return reqData;
    },
    showDialogMsgAfterAPICall : function(responseDto) {
      let hasError = false;
      // APIコール異常
      if (responseDto == null) {
        hasError = true;
        this.dlgErrMsg.msg = this.$i18n.t('msg.err.cm110', ['本人確認の依頼']);
        this.dlgErrMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseDto.statusCd != 200) {
        // 処理異常
        hasError = true;
        let errorList = responseDto.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgErrMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgErrMsg.isOpen = true;
          return hasError;
        }  
      }
      return hasError;
    },
    regsterVerifyResult: async function(requestResultData) {
      let responseDto;
      let pramRequestNo = Utils.removeChar(this.requestNo, "-");
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let apiurl = Constants.getUrlApiURL_API_MTR300P01(pramRequestNo);
        // 入力データ
        let data = JSON.stringify(requestResultData);
        // API呼出
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseDto = response.data;
        if (responseDto.statusCd != 200) {
          this.dlgErrMsg.msg = responseDto.message;
          this.dlgErrMsg.isOpen = true;
        } else {
          this.dlgMsgCompled.msg = responseDto.message;
          this.dlgMsgCompled.isOpen = true;
        }
      } catch(error) {
        this.dlgErrMsg.msg = this.$i18n.t('msg.err.cm110', ['本人確認の依頼']);
        this.dlgErrMsg.isOpen = true;
      } 
      this.doYes();
      this.verifyRequestDialog = false;
    },

  },
};
</script>
<style scoped>
#name-text:disabled {
  color: red !important;
}
.v-input--is-disabled {
  color: aqua;
}
</style>